import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Tierarzt } from '../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';

@Injectable({ providedIn: 'root' })
export class VetService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    getVetForId(id: number): Observable<Tierarzt> {
        const params = new HttpParams().set('tierarzt_id', id.toString());
        return this.http.get<Tierarzt>(this.apiBaseUrl + 'tierarzt/read_one.php', { params: params });
    }
}
